import React, {useState, useEffect} from 'react';
//import useWebSocket from 'react-use-websocket';
import useWebSocket from 'react-use-websocket';
//import io from 'socket.io-client';





// PROTESTATION SCREENS ------------------------------------------------------------------------------
import { SlovLobbyScreen } from './slovLobby';
import { SlovTypeScreen } from './slovType';
import { SlovTriviaScreen } from './slovTrivia';
import { SlovColorcodeScreen } from './slovColorcode';
import { SlovGlassScreen } from './slovGlass';
import { SlovVoiceScreen } from './slovVoice';
import { SlovLocationScreen } from './slovLocation';
import { SlovLotteryScreen } from './slovLottery';
import { SlovRowsScreen } from './slovRows';
import { SlovCellsScreen } from './slovCells';

// KCATS NIGHT (DELETE AFTER NIGHT) ------------------------------------------------------------------
import { KCATSNIGHT_SlovWaitingScreen } from './KCATSNIGHT_slovWaiting';
import { KCATSNIGHT_SlovMemesSendScreen } from './KCATSNIGHT_slovMemesSend';
import { KCATSNIGHT_SlovMemesSend2Screen } from './KCATSNIGHT_slovMemesSend2';
import { KCATSNIGHT_slovMemesVoteScreen } from './KCATSNIGHT_slovMemesVote';
import { KCATSNIGHT_slovButtonScreen } from './KCATSNIGHT_slovButton';
import { KCATSNIGHT_slovTypeScreen } from './KCATSNIGHT_slovType';
// ---------------------------------------------------------------------------------------------------

// FIBBY.IO (DELETE AFTER NIGHT) ------------------------------------------------------------------
import { KCATSNIGHT_slovkcatsfibbychoiceScreen } from './KCATSNIGHT_slovkcatsfibbychoice';
import { KCATSNIGHT_slovkcatsfibbylieScreen } from './KCATSNIGHT_slovkcatsfibbylie';
import { KCATSNIGHT_slovkcatsfibbytruthScreen } from './KCATSNIGHT_slovkcatsfibbytruth';
import { KCATSNIGHT_slovkcatsfibbypickScreen } from './KCATSNIGHT_slovkcatsfibbypick';
// ---------------------------------------------------------------------------------------------------

// CRIMINALIST (DELETE (OR NOT) AFTER NIGHT) ------------------------------------------------------------------
import { KCATSNIGHT_slovkcatscriminalhostScreen } from './KCATSNIGHT_slovkcatscriminalhost';
import { KCATSNIGHT_slovkcatscriminalguessScreen } from './KCATSNIGHT_slovkcatscriminalguess';
import { KCATSNIGHT_slovkcatscriminalguessrightScreen } from './KCATSNIGHT_slovkcatscriminalguessright';
/*
import { KCATSNIGHT_slovkcatscriminalvoteforskipScreen } from './KCATSNIGHT_slovkcatscriminalvoteforskip';
import { KCATSNIGHT_slovkcatscriminalwaitScreen } from './KCATSNIGHT_slovkcatscriminalwait';
*/

// DOOMINATE CYBERBOX EDITION ------------------------------------------------------------------------------
import { DoomPickOneToRuinScreen } from './doomPickOneToRuin';
import { DoomRuinScreen } from './doomRuin';
import { DoomThinkScreen } from './doomThink';
import { DoomWaitScreen } from './doomWait';
import { DoomVoteScreen } from './doomVote';


// CARDS GAME ------------------------------------------------------------------------------
import { CardsWaitScreen } from './CardsWaitScreen';
import { CardsCategoriesScreen } from './CardsCategoriesScreen';
import { CardsDescLongScreen } from './CardsDescLongScreen';
import { CardsDescShortScreen } from './CardsDescShortScreen';
import { CardsGreetingScreen } from './CardsGreetingScreen';
import { CardsVoteScreen } from './CardsVoteScreen';
import { CardsDecorScreen } from './CardsDecorScreen';
import { CardsFinalPickScreen } from './CardsFinalPickScreen';
import { CardsFinalGreetingScreen } from './CardsFinalGreetingScreen';
import { CardsFinalDecorScreen } from './CardsFinalDecorScreen';
import { CardsEndScreen } from './CardsEndScreen';
import { CardsSkipScreen } from './CardsSkipScreen';

// TEST KIKETSURING ------------------------------------------------------------------------------
import { KCatsTuringChatScreen } from './KCatsTuringChatScreen';
import { KCatsTuringSpecialScreen } from './KCatsTuringSpecialScreen';
import { KCatsTuringFinalVoteScreen } from './KCatsTuringFinalVoteScreen';
import { KCatsTuringWaitScreen } from './KCatsTuringWaitScreen';
// GUARDIANRUNE / DELTA BATTLE -----------------------------------------------------------------------
import { DeltaWaitScreen } from './DeltaWaitScreen';
import { DeltaPlayer1GameScreen } from './DeltaPlayer1GameScreen';
import { DeltaPlayer2GameScreen } from './DeltaPlayer2GameScreen';
import { DeltaPlayer3GameScreen } from './DeltaPlayer3GameScreen';
import { DeltaPlayer4GameScreen } from './DeltaPlayer4GameScreen';
import { DeltaPlayer5GameScreen } from './DeltaPlayer5GameScreen';
import { DeltaPlayer6GameScreen } from './DeltaPlayer6GameScreen';
import { DeltaPlayer7GameScreen } from './DeltaPlayer7GameScreen';
import { DeltaPlayer8GameScreen } from './DeltaPlayer8GameScreen';

// ---------------------------------------------------------------------------------------------------





 const socketUrl = 'wss://cyberbox.trgu.ru/api/';



const decodeKcatsTuringPayload = (rawValue, fallback = []) => {
  try {
    return JSON.parse(decodeURIComponent(rawValue || ""));
  } catch (error) {
    console.error("KCATSTURING payload parse error:", error, rawValue);
    return fallback;
  }
};

export const SlovMainGame = (props) =>
{
const [returnstring, setreturnstring] = useState("");
const [GScreen, setGScreen] = useState(0);
const [slovLastMsg, setslovLastMsg] = useState("");
const [GNotStarted, setGNotStarted] = useState(false);
const [slovGamePoints, setslovGamePoints] = useState(0);
const [SentInfo, setSentInfo] = useState("");
const [SentInfo2, setSentInfo2] = useState("");
const [SentInfo3, setSentInfo3] = useState("");
const [SentInfo4, setSentInfo4] = useState("");
const [SentInfo5, setSentInfo5] = useState("");
const [SentInfo6, setSentInfo6] = useState("");
const [SentInfo7, setSentInfo7] = useState("");
const [SentInfo8, setSentInfo8] = useState("");
const [SentInfo9, setSentInfo9] = useState("");
const [SentInfo10, setSentInfo10] = useState("");
const [SentInfo11, setSentInfo11] = useState("");
const [SentInfo12, setSentInfo12] = useState("");

// TEST KIKETSURING STATE
const [KcatsTuringNormalData, setKcatsTuringNormalData] = useState({
  round: 0, chatId: -1, selfIndex: 0, messages: []
});
const [KcatsTuringSpecialData, setKcatsTuringSpecialData] = useState({
  round: 0, chats: []
});
const [KcatsTuringLastUpdate, setKcatsTuringLastUpdate] = useState(null);
const [KcatsTuringReject, setKcatsTuringReject] = useState(null);
// GUARDIANRUNE / DELTA BATTLE STATE
const [DeltaAttackEnabled, setDeltaAttackEnabled] = useState(false);
const [DeltaHealEnabled, setDeltaHealEnabled] = useState(false);
const [DeltaStateReason, setDeltaStateReason] = useState("waiting");

useEffect(() => {
    setGScreen(0);//-------------------------------------------------------------------------------ЭКРАНЫ
  }, []);

const handleSlovMessage = (Wmsg) =>
{
  console.log("slovoblud raw + " + Wmsg); 
  if(Wmsg.includes("\\"))
  {
  var msg = Wmsg.split("\\");
  console.log("slovoblud + " + msg);
  switch (msg[1])
  {
    case "setSlovPoints":
      setslovGamePoints(msg[2]);
    break;
    case "startscreen":
    setGNotStarted(true);
    setGScreen(0);
    break;
    case "typescreen":
    setGScreen(1);
    break;
    case "triviascreen":
    setGScreen(2);
    break;
    case "colorcodescreen":
    setGScreen(3);
    break;
    case "glassscreen":
    setGScreen(4);
    break;
    case "voicescreen":
    setSentInfo(msg[2]);
    setSentInfo2(msg[3]);
    setSentInfo3(msg[4]);
    setGScreen(5);
    break;
    case "locationscreen":
    setSentInfo(msg[2]);
    setGScreen(6);
    break;
    case "lotteryscreen":
    setGScreen(7);
    break;
    case "rowsscreen":
    setSentInfo(msg[2]);
    setSentInfo2(msg[3]);
    setGScreen(8);
    break;
    case "cellsscreen":
    setSentInfo(msg[2]);
    setGScreen(9);
    break



    // KCATS NIGHT SCREENS
    case "kcatswaitingscreen":
    setGScreen(100);
    break
    case "kcatsmemingsendscreen":
    setSentInfo(msg[2]);
    setSentInfo2(msg[3]);
    setGScreen(101);
    break;
    case "kcatsmemingsend2screen":
    setSentInfo(msg[2]);
    setSentInfo2(msg[3]);
    setGScreen(103);
    break;
    case "kcatsmemingvotescreen":
    setSentInfo(msg[2]);
    setSentInfo2(msg[3]);
    setGScreen(102);
    break;
    case "kcatsbutton":
    setGScreen(104);
    break
    case "kcatstype":
    setGScreen(105);
    break


    //FIBBY.IO
    case "slovkcatsfibbychoice":
    setGScreen(106);
    break
    case "slovkcatsfibbylie":
    setGScreen(107);
    break
    case "slovkcatsfibbytruth":
    setSentInfo(msg[2]);
    setGScreen(108);
    break
    case "slovkcatsfibbypick":
    setSentInfo(msg[2]);
    setGScreen(109);
    break

    //CRIMINALIST
    case "slovkcatscriminalhost":
    setGScreen(110);
    break
    case "slovkcatscriminalguess":
    setGScreen(111);
    break
    case "slovkcatscriminalguessright":
    setGScreen(112);
    break


    //DOOMINATE CYBERBOX
    case "doomwait":
    setGScreen(200);
    break
    case "doompickonetoruin":
    setSentInfo(msg[2]);
    setSentInfo2(msg[3]);
    setSentInfo3(msg[4]);
    setSentInfo4(msg[5]);
    setGScreen(201);
    break
    case "doomruin":
    setSentInfo(msg[2]);
    setSentInfo2(msg[3]);
    setGScreen(202);
    break
    case "doomvote":
    setSentInfo(msg[2]);
    setSentInfo2(msg[3]);
    setGScreen(204);
    break
    case "doomthink":
    setSentInfo(msg[2]);
    setSentInfo2(msg[3]);
    setGScreen(203);
    break




    // TEST KIKETSURING
    case "kcatsuring_chat":
      setKcatsTuringNormalData({
        round: Number(msg[2]) || 0,
        chatId: Number(msg[3]),
        selfIndex: Number(msg[4]) || 0,
        messages: decodeKcatsTuringPayload(msg[5], [])
      });
      setKcatsTuringLastUpdate(null);
      setKcatsTuringReject(null);
      setGScreen(400);
    break;

    case "kcatsuring_special":
      setKcatsTuringSpecialData({
        round: Number(msg[2]) || 0,
        chats: decodeKcatsTuringPayload(msg[3], [])
      });
      setKcatsTuringLastUpdate(null);
      setKcatsTuringReject(null);
      setGScreen(401);
    break;

    case "kcatsuring_chat_update":
      setKcatsTuringLastUpdate({
        chatId: Number(msg[2]),
        messages: decodeKcatsTuringPayload(msg[3], []),
        count0: Number(msg[4]) || 0,
        count1: Number(msg[5]) || 0,
        serial: Date.now() + Math.random()
      });
    break;

    case "kcatsuring_message_rejected":
      setKcatsTuringReject({
        reason: msg[2] || "unknown",
        chatId: Number(msg[3]),
        serial: Date.now() + Math.random()
      });
    break;

    case "kcatsuring_final_vote":
      setKcatsTuringReject(null);
      setGScreen(402);
    break;

    case "kcatsturingwaitingscreen":
      setGScreen(403);
    break;

    // GUARDIANRUNE / DELTA BATTLE
    case "delta_waitscreen":
      setDeltaAttackEnabled(false);
      setDeltaHealEnabled(false);
      setDeltaStateReason("waiting");
      setGScreen(500);
    break;

    case "delta_player1gamescreen":
      setDeltaAttackEnabled(false);
      setDeltaHealEnabled(false);
      setDeltaStateReason("waiting");
      setGScreen(501);
    break;

    case "delta_player2gamescreen":
      setDeltaAttackEnabled(false);
      setDeltaHealEnabled(false);
      setDeltaStateReason("waiting");
      setGScreen(502);
    break;

    case "delta_player3gamescreen":
      setDeltaAttackEnabled(false);
      setDeltaHealEnabled(false);
      setDeltaStateReason("waiting");
      setGScreen(503);
    break;

    case "delta_player4gamescreen":
      setDeltaAttackEnabled(false);
      setDeltaHealEnabled(false);
      setDeltaStateReason("waiting");
      setGScreen(504);
    break;

    case "delta_player5gamescreen":
      setDeltaAttackEnabled(false);
      setDeltaHealEnabled(false);
      setDeltaStateReason("waiting");
      setGScreen(505);
    break;

    case "delta_player6gamescreen":
      setDeltaAttackEnabled(false);
      setDeltaHealEnabled(false);
      setDeltaStateReason("waiting");
      setGScreen(506);
    break;

    case "delta_player7gamescreen":
      setDeltaAttackEnabled(false);
      setDeltaHealEnabled(false);
      setDeltaStateReason("waiting");
      setGScreen(507);
    break;

    case "delta_player8gamescreen":
      setDeltaAttackEnabled(false);
      setDeltaHealEnabled(false);
      setDeltaStateReason("waiting");
      setGScreen(508);
    break;

    case "delta_state":
      setDeltaAttackEnabled(msg[2] === "1");
      setDeltaHealEnabled(msg[3] === "1");
      setDeltaStateReason(msg[4] || "waiting");
    break;


    // CARDS GAME
    case "cardswait":
    setGScreen(300);
    break

    case "cardscategories":
    setSentInfo(msg[2]);
    setSentInfo2(msg[3]);
    setSentInfo3(msg[4]);
    setGScreen(301);
    break

    case "cardsdesclong":
    setSentInfo(msg[2]);
    setGScreen(302);
    break

    case "cardsdescshort":
    setSentInfo(msg[2]);
    setGScreen(303);
    break

    case "cardsgreeting":
    setSentInfo(msg[2]);
    setGScreen(304);
    break

    case "cardsvote":
    setGScreen(305);
    break

    case "cardsdecor":
    setSentInfo(msg[2]);
    setSentInfo2(msg[3]);
    setSentInfo3(msg[4]);
    setSentInfo4(msg[5]);
    setGScreen(306);
    break

    case "cardsfinalpick":
    setSentInfo(msg[2]);
    setSentInfo2(msg[3]);
    setSentInfo3(msg[4]);
    setSentInfo4(msg[5]);
    setSentInfo5(msg[6]);
    setSentInfo6(msg[7]);
    setSentInfo7(msg[8]);
    setSentInfo8(msg[9]);
    setSentInfo9(msg[10]);
    setSentInfo10(msg[11]);
    setSentInfo11(msg[12]);
    setSentInfo12(msg[13]);
    setGScreen(307);
    break

    case "cardsfinalgreeting":
    setSentInfo(msg[2]);
    setSentInfo2(msg[3]);
    setSentInfo3(msg[4]);
    setGScreen(308);
    break

    case "cardsfinaldecor":
    setSentInfo(msg[2]);
    setSentInfo2(msg[3]);
    setSentInfo3(msg[4]);
    setSentInfo4(msg[5]);
    setSentInfo5(msg[6]);
    setSentInfo6(msg[7]);
    setSentInfo7(msg[8]);
    setGScreen(309);
    break

    case "cardsend":
    setGScreen(310);
    break

    case "cardsskip":
    setGScreen(311);
    break

    /*
    case "slovkcatscriminalvoteforskip":
    setGScreen(113);
    break
    case "slovkcatscriminalwait":
    setGScreen(114);
    break
    */
  }
}
}
/*
if(protLastMsg != props.WSMessage)
{
console.log(typeof WSMessage);
setprotLastMsg(props.WSMessage);
handleProtMessage(props.WSMessage);
}
*/
useEffect(() => {
  handleSlovMessage(props.WSMessage);
}, 
[props.WSMessage]);
/*
GameStates
|| Протестейшн
0 - (Протестейшн) Лобби протестейшна
1 - (Протестейшн) Туториал протестейшна
2 - (Протестейшн) Выбор темы протестейшна
3 - (Протестейшн) Экран лектора протестейшна
4 - (Протестейшн) Экран игрока протестейшна
5 - (Протестейшн) Экран судьи протестейшна
6 - (Протестейшн) Экран принятия протеста
7 - (Протестейшн) Экран оценки судьи
*/
useEffect(() => {
    switch (GScreen)
    {
    case 0:
    setreturnstring(<SlovLobbyScreen PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 1:
    setreturnstring(<SlovTypeScreen PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 2:
    setreturnstring(<SlovTriviaScreen PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 3:
    setreturnstring(<SlovColorcodeScreen PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 4:
    setreturnstring(<SlovGlassScreen PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 5:
    setreturnstring(<SlovVoiceScreen ColorString = {SentInfo} TextString = {SentInfo2} TextString2 = {SentInfo3}  PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 6:
    setreturnstring(<SlovLocationScreen TextString = {SentInfo}  PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 7:
    setreturnstring(<SlovLotteryScreen PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 8:
    setreturnstring(<SlovRowsScreen TextString = {SentInfo} TextString2 = {SentInfo2}  PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 9:
    setreturnstring(<SlovCellsScreen TextString = {SentInfo} PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;



    
    // KCATS NIGHT SCREENS
    case 100:
    setreturnstring(<KCATSNIGHT_SlovWaitingScreen PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 101:
    setreturnstring(<KCATSNIGHT_SlovMemesSendScreen TextString = {SentInfo} TextString2 = {SentInfo2} PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 102:
    setreturnstring(<KCATSNIGHT_slovMemesVoteScreen TextString = {SentInfo} TextString2 = {SentInfo2} PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 103:
    setreturnstring(<KCATSNIGHT_SlovMemesSend2Screen TextString = {SentInfo} TextString2 = {SentInfo2} PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 104:
    setreturnstring(<KCATSNIGHT_slovButtonScreen PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 105:
    setreturnstring(<KCATSNIGHT_slovTypeScreen PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;

    //FIBBY.IO
    case 106:
    setreturnstring(<KCATSNIGHT_slovkcatsfibbychoiceScreen PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 107:
    setreturnstring(<KCATSNIGHT_slovkcatsfibbylieScreen PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 108:
    setreturnstring(<KCATSNIGHT_slovkcatsfibbytruthScreen TextString = {SentInfo} PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 109:
    setreturnstring(<KCATSNIGHT_slovkcatsfibbypickScreen TextString = {SentInfo} PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;

    //CRIMINALIST
    case 110:
    setreturnstring(<KCATSNIGHT_slovkcatscriminalhostScreen PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 111:
    setreturnstring(<KCATSNIGHT_slovkcatscriminalguessScreen PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 112:
    setreturnstring(<KCATSNIGHT_slovkcatscriminalguessrightScreen PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;


    //DOOMINATE CYBERBOX
    case 200:
    setreturnstring(<DoomWaitScreen PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 201:
    setreturnstring(<DoomPickOneToRuinScreen TextString = {SentInfo} TextString2 = {SentInfo2} TextString3 = {SentInfo3} TextString4 = {SentInfo4} PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 202:
    setreturnstring(<DoomRuinScreen TextString = {SentInfo2} TextString2 = {SentInfo} PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 204:
    setreturnstring(<DoomVoteScreen TextString = {SentInfo} TextString2 = {SentInfo2} PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    case 203:
    setreturnstring(<DoomThinkScreen TextString = {SentInfo} TextString2 = {SentInfo2} PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
    

    // TEST KIKETSURING
    case 400:
    setreturnstring(<KCatsTuringChatScreen data={KcatsTuringNormalData} update={KcatsTuringLastUpdate} reject={KcatsTuringReject} PColors={props.PColor} fsetPingt={props.setPingt} prName={props.PName} prCode={props.RCode} CBcolor={props.ChangeBColor} sendMessage={props.sendMessage} slovGamePoints={slovGamePoints}/>);
    break;

    case 401:
    setreturnstring(<KCatsTuringSpecialScreen data={KcatsTuringSpecialData} update={KcatsTuringLastUpdate} reject={KcatsTuringReject} PColors={props.PColor} fsetPingt={props.setPingt} prName={props.PName} prCode={props.RCode} CBcolor={props.ChangeBColor} sendMessage={props.sendMessage} slovGamePoints={slovGamePoints}/>);
    break;

    case 402:
    setreturnstring(<KCatsTuringFinalVoteScreen PColors={props.PColor} fsetPingt={props.setPingt} prName={props.PName} prCode={props.RCode} CBcolor={props.ChangeBColor} sendMessage={props.sendMessage} slovGamePoints={slovGamePoints}/>);
    break;

    case 403:
    setreturnstring(<KCatsTuringWaitScreen PColors = {props.PColor}  fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode}  CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break
    

    // GUARDIANRUNE / DELTA BATTLE
    case 500:
    setreturnstring(<DeltaWaitScreen PColors={props.PColor} fsetPingt={props.setPingt} prName={props.PName} prCode={props.RCode} CBcolor={props.ChangeBColor} sendMessage={props.sendMessage} slovGamePoints={slovGamePoints}/>);
    break;

    case 501:
    setreturnstring(<DeltaPlayer1GameScreen attackEnabled={DeltaAttackEnabled} healEnabled={DeltaHealEnabled} stateReason={DeltaStateReason} PColors={props.PColor} fsetPingt={props.setPingt} prName={props.PName} prCode={props.RCode} CBcolor={props.ChangeBColor} sendMessage={props.sendMessage} slovGamePoints={slovGamePoints}/>);
    break;

    case 502:
    setreturnstring(<DeltaPlayer2GameScreen attackEnabled={DeltaAttackEnabled} healEnabled={DeltaHealEnabled} stateReason={DeltaStateReason} PColors={props.PColor} fsetPingt={props.setPingt} prName={props.PName} prCode={props.RCode} CBcolor={props.ChangeBColor} sendMessage={props.sendMessage} slovGamePoints={slovGamePoints}/>);
    break;

    case 503:
    setreturnstring(<DeltaPlayer3GameScreen attackEnabled={DeltaAttackEnabled} healEnabled={DeltaHealEnabled} stateReason={DeltaStateReason} PColors={props.PColor} fsetPingt={props.setPingt} prName={props.PName} prCode={props.RCode} CBcolor={props.ChangeBColor} sendMessage={props.sendMessage} slovGamePoints={slovGamePoints}/>);
    break;

    case 504:
    setreturnstring(<DeltaPlayer4GameScreen attackEnabled={DeltaAttackEnabled} healEnabled={DeltaHealEnabled} stateReason={DeltaStateReason} PColors={props.PColor} fsetPingt={props.setPingt} prName={props.PName} prCode={props.RCode} CBcolor={props.ChangeBColor} sendMessage={props.sendMessage} slovGamePoints={slovGamePoints}/>);
    break;

    case 505:
    setreturnstring(<DeltaPlayer5GameScreen attackEnabled={DeltaAttackEnabled} healEnabled={DeltaHealEnabled} stateReason={DeltaStateReason} PColors={props.PColor} fsetPingt={props.setPingt} prName={props.PName} prCode={props.RCode} CBcolor={props.ChangeBColor} sendMessage={props.sendMessage} slovGamePoints={slovGamePoints}/>);
    break;

    case 506:
    setreturnstring(<DeltaPlayer6GameScreen attackEnabled={DeltaAttackEnabled} healEnabled={DeltaHealEnabled} stateReason={DeltaStateReason} PColors={props.PColor} fsetPingt={props.setPingt} prName={props.PName} prCode={props.RCode} CBcolor={props.ChangeBColor} sendMessage={props.sendMessage} slovGamePoints={slovGamePoints}/>);
    break;

    case 507:
    setreturnstring(<DeltaPlayer7GameScreen attackEnabled={DeltaAttackEnabled} healEnabled={DeltaHealEnabled} stateReason={DeltaStateReason} PColors={props.PColor} fsetPingt={props.setPingt} prName={props.PName} prCode={props.RCode} CBcolor={props.ChangeBColor} sendMessage={props.sendMessage} slovGamePoints={slovGamePoints}/>);
    break;

    case 508:
    setreturnstring(<DeltaPlayer8GameScreen attackEnabled={DeltaAttackEnabled} healEnabled={DeltaHealEnabled} stateReason={DeltaStateReason} PColors={props.PColor} fsetPingt={props.setPingt} prName={props.PName} prCode={props.RCode} CBcolor={props.ChangeBColor} sendMessage={props.sendMessage} slovGamePoints={slovGamePoints}/>);
    break;

        // CARDS GAME
    case 300:
    setreturnstring(<CardsWaitScreen PColors = {props.PColor} fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode} CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;

    case 301:
    setreturnstring(<CardsCategoriesScreen TextString = {SentInfo} TextString2 = {SentInfo2} TextString3 = {SentInfo3} PColors = {props.PColor} fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode} CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;

    case 302:
    setreturnstring(<CardsDescLongScreen TextString = {SentInfo} PColors = {props.PColor} fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode} CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;

    case 303:
    setreturnstring(<CardsDescShortScreen TextString = {SentInfo} PColors = {props.PColor} fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode} CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;

    case 304:
    setreturnstring(<CardsGreetingScreen TextString = {SentInfo} PColors = {props.PColor} fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode} CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;

    case 305:
    setreturnstring(<CardsVoteScreen PColors = {props.PColor} fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode} CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;

    case 306:
    setreturnstring(<CardsDecorScreen TextString = {SentInfo} TextString2 = {SentInfo2} TextString3 = {SentInfo3} TextString4 = {SentInfo4} PColors = {props.PColor} fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode} CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;

    case 307:
    setreturnstring(<CardsFinalPickScreen TextString = {SentInfo} TextString2 = {SentInfo2} TextString3 = {SentInfo3} TextString4 = {SentInfo4} TextString5 = {SentInfo5} TextString6 = {SentInfo6} TextString7 = {SentInfo7} TextString8 = {SentInfo8} TextString9 = {SentInfo9} TextString10 = {SentInfo10} TextString11 = {SentInfo11} TextString12 = {SentInfo12} PColors = {props.PColor} fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode} CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;

    case 308:
    setreturnstring(<CardsFinalGreetingScreen TextString = {SentInfo} TextString2 = {SentInfo2} TextString3 = {SentInfo3} PColors = {props.PColor} fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode} CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;

    case 309:
    setreturnstring(<CardsFinalDecorScreen TextString = {SentInfo} TextString2 = {SentInfo2} TextString3 = {SentInfo3} TextString4 = {SentInfo4} TextString5 = {SentInfo5} TextString6 = {SentInfo6} TextString7 = {SentInfo7} PColors = {props.PColor} fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode} CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;

    case 310:
    setreturnstring(<CardsEndScreen PColors = {props.PColor} fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode} CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;

    case 311:
    setreturnstring(<CardsSkipScreen PColors = {props.PColor} fsetPingt = {props.setPingt} prName = {props.PName} prCode = {props.RCode} CBcolor = {props.ChangeBColor} sendMessage = {props.sendMessage} slovGamePoints = {slovGamePoints}/>);
    break;
  } 
}, [
  GScreen,
  slovGamePoints,
  SentInfo,
  SentInfo2,
  SentInfo3,
  SentInfo4,
  SentInfo5,
  SentInfo6,
  SentInfo7,
  SentInfo8,
  SentInfo9,
  SentInfo10,
  SentInfo11,
  SentInfo12,
  KcatsTuringNormalData,
  KcatsTuringSpecialData,
  KcatsTuringLastUpdate,
  KcatsTuringReject,
  DeltaAttackEnabled,
  DeltaHealEnabled,
  DeltaStateReason
]);
return(
  returnstring
  );
}